export const config = {
  // REACT_APP_API_ENDPOINT:"https://image-service-api.staging.ntx.ventures",
  REACT_APP_API_ENDPOINT: "http://localhost:4000/api",
  REACT_APP_SECRET_KEY:
    "ad;gkhasdgi;dh'p;ih34;23k4j5;kahsd;khzsdflkh2345l2kh346-p9aydvaposdfalmndv",
};
